export const trackEnquiryTypeFormSubmit = (formName, isCorporate = false) => {
  if (typeof window === "undefined") return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "enquiry_type_form_submit",
    form_name: formName,
    enquiry_type: isCorporate ? "corporate" : "individual",
  });
};
